import { ReactElement } from 'react';
import { Box, Chip, CircularProgress } from '@mui/material';
import { ChipProps } from '@mui/material/Chip';

export interface LoadingChipProps extends Omit<ChipProps, 'icon'> {
  /** Chip label (e.g. "En curso"). */
  label: ChipProps['label'];
  /** When false and loadedIcon is set, shows loadedIcon instead of spinner. Default true. */
  loading?: boolean;
  /** Icon to show when loading is false. Must be a ReactElement for MUI Chip icon prop. */
  loadedIcon?: ReactElement;
}

/**
 * Chip with a spinner on the left. Use for in-progress or loading states.
 * When loading is false and loadedIcon is provided, shows that icon instead.
 */
export function LoadingChip({
  label,
  size = 'small',
  color = 'info',
  loading = true,
  loadedIcon,
  ...rest
}: LoadingChipProps) {
  const spinnerSize = size === 'small' ? 10 : 14;
  const showLoadedIcon = !loading && loadedIcon != null;

  return (
    <Chip
      size={size}
      color={color}
      icon={
        showLoadedIcon ? (
          loadedIcon
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', px: 0.5 }}>
            <CircularProgress size={spinnerSize} color="inherit" />
          </Box>
        )
      }
      label={label}
      {...rest}
    />
  );
}
